import React from 'react'

import { View, StyleSheet, Linking, ScrollView, Platform } from 'react-native'

import { useClient, client } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, backgroundColors, typography } from '@sart/styles'
import { testID } from '@sart/utilities'
import { Select, Button, Space, MenuList } from '@sart/components'
import { LanguageIconType } from '@sart/icons'
import { link } from 'superagent'

export default function Menu(props) {
  const content = useContent()

  const { navigation } = props

  const { cache } = useClient()

  async function handleLogout() {
    try {
      await client.signOutAndForget()
      navigation.popToTop()
      navigation.navigate('Sign', { screen: 'SignIn' })
    } catch (error) {
      console.log(error)
    }
  }

  function handleRouting(item) {
    if (item.link) {
      return Linking.openURL(item.link + '?time=' + Date.now().toString())
    }
    navigation.navigate(item.id)
  }

  const backToMenu = true
  async function changeLanguage(option) {
    await client.updateLanguage(client.cache.userId, option.value)

    navigation.setParams({ refreshed: true })
  }

  const menuItems = [
    // {id: 'Usage', label: 'Usage' },
    { id: 'Account', label: content.profile.accountLabel, },
    { id: 'PaymentHistory', label: content.navigation.paymentHistory, },
    { id: 'ManageSubscription', label: content.profile.manageSubscriptionLabel, },
    // {id: 'Notifications', label: 'Notifications' },
    // {id: 'Preferences', label: 'Preferences' },
    { id: 'FAQs', label: content.menu.faqs, link: 'https://www.bikermobile.com/faqs' },
    { id: 'Chat', label: content.help.chat, link: 'https://www.bikermobile.com/im_livechat/support/4' },
    { id: 'Legal', label: content.legal.header }
    // {id: 'HelpScreen', label: content.menu.help}
  ]

  return (
    <ScrollView contentContainerStyle={styles.wrapper}>
      <View style={styles.widthRestrictions}>
        <MenuList color={colors.brightOrange}>
          {
            menuItems.map(item =>
              <MenuList.Item
                key={item.id}
                label={item.label}
                onPress={() => handleRouting(item)}
                style={styles.menuListItemStyle}
                {...testID(item.id)}
              />
            )
          }
        </MenuList>

        <Space height={24} />


        {/* TODO - removing this currently as we aren't supporting multiple languages for launch
        <Select
          label={content.menu.language}
          value={cache.language}
          icon={<LanguageIconType 
            type={cache.language}
            {...Platform.select({
              android: { style: styles.flagIcon }
            })}
          />}
          options={[
            { label: content.languages.en, value: 'en' },
            // { label: content.languages.es, value: 'es' }
          ]}
          onOptionChange={option => {
            changeLanguage(option)
          }}
          containerStyle={styles.selectStyle}
          labelStyle={styles.labelStyles}
          inputStyles={styles.inputStyles}
          injectedContent={content}
          {...testID('selectLanguage')}
        /> */}

        <Space height={24} />

        <Button
          title={content.navigation.logout}
          onPress={handleLogout}
          style={styles.logoutButtonStyle}
          titleStyle={{ ...typography.extrabold, fontSize: 18 }}
          {...testID('logoutButton')}
        />
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    ...adaptive.menuPaddingTop,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
    backgroundColor: backgroundColors.darkCharcoal,
    width: '100%',
    alignItems: 'center'
  },
  selectStyle: {
    borderWidth: 1,
    // backgroundColor: backgroundColors.feature,
    color: colors.srGreen,
    borderColor: colors.srGreen,
    borderRadius: 4
  },
  logoutButtonStyle: {
    backgroundColor: colors.brightOrange,
    marginTop: 'auto',
    marginBottom: '15%'
  },
  flagIcon: {
    alignSelf: 'center',
    position: 'absolute',
    right: '15%',
    bottom: '30%'
  },
  menuListItemStyle: {
    color: colors.white,
    ...typography.lightbold
  },
  labelStyles: {
    ...typography.demi
  },
  inputStyles: {
    ...typography.medium
  },
  spaceHeight: {
    ...adaptive.menuSpaceHeight
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600
  }
})
